import { styled } from '@mui/material/styles';
import { baseStyles } from '../../common/baseStyles';
export const StyledSnackbarContentContainer = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '14px',
    padding: '4px 8px 4px 12px',
    borderRadius: '4px',
    boxShadow: theme.tokens.BaseShadowMd,
    backgroundColor: theme.tokens.ComponentSnackbarColorBackground,
    alignItems: 'center',
    minWidth: '160px',
    maxWidth: '390px',
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    ...baseStyles
  };
});